<template>
  <DataGrid
      ref="dataGrid"
      :data-model="dataGridModel"
      :data="filteredDevices"
      :selected-id="selectedDeviceId"
      default-sort-by="name"
      allow-select
      @on-select="selectDeviceId"
      class="fixed-header"
  />
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import {entityDataManager, WorkflowManager} from '@/assets/js/data-manipulation';
import moment from 'moment';
import DataGrid from '@/components/pages/partials/DataGrid';
import {EventSeverity} from "@/assets/js/events-info";
import {DashboardDeviceColumn} from "@/assets/js/enums/DashboardDeviceColumn.js";

export default {
  name: 'DevicesCard',
  components: {DataGrid},
  props: {
    selectedDeviceId: {
      type: [Number, null],
      default: null,
    },
    filteredDevices: Array,
  },
  computed: {
    ...mapState(['devices', 'vehicles', 'events', 'deviceIgnitions']),
    ...mapGetters(['isGroupShown', 'dashboardDeviceColumns']),
    dataGridModel() {
      let headers = {
        ['']: 'icon',
        [this.$t('dashboard.devices.table.status')]: 'status',
      };

      if (this.dashboardDeviceColumns?.length > 0) {
        DashboardDeviceColumn.all().forEach(columnData => {
          if (!this.dashboardDeviceColumns?.includes(columnData.value)) {
            return;
          }

          headers[this.$t(columnData.translationKey)] = columnData.value;
        });
      }
      else {
        const nameColumnData = DashboardDeviceColumn.get(DashboardDeviceColumn.Name);
        headers[this.$t(nameColumnData.translationKey)] = nameColumnData.value;
      }

      if (this.isGroupShown) {
        const groupNameColumnData = DashboardDeviceColumn.get(DashboardDeviceColumn.Group);
        headers[this.$t(groupNameColumnData.translationKey)] = groupNameColumnData.value;
      }

      return {
        headers: headers,
        values: {
          icon: device => this.getIcon(device.id),
          status: device => this.statusLabel(device.id),
        },
        actions: [
          {icon: 'bi bi-card-list', handler: this.openTrips},
        ],
      };
    },
  },
  watch: {
    filteredDevices(devices) {
      if (this.selectedDeviceId === null) {
        this.selectFirstDevice(devices);
      }
    },
    selectedDeviceId() {
      setTimeout(() => this.$refs.dataGrid.scrollToSelectedRow());
    }
  },
  methods: {
    selectFirstDevice(devices) {
      const deviceId = devices[0]?.id || null;
      this.selectDeviceId(deviceId);
    },
    selectDeviceId(id) {
      this.$emit('on-select-device', id);
    },
    getIcon(deviceId) {
      const result = {class: 'width-15', message: ''};

      const event = entityDataManager.getLastNonSeenEventByDeviceIdAndSeverity(this.events, deviceId, EventSeverity.warning);
      if (event) {
        result.icon = 'bi bi-exclamation-circle-fill font-size-24 text-danger px-20';
      }

      return result;
    },
    statusLabel(deviceId) {
      const ignition = entityDataManager.getDeviceIgnition(deviceId, this.deviceIgnitions);
      return ignition ? '🟢' : '🔴';
    },
    openTrips(device) {
      const fromDate = moment().startOf('day').subtract(1, 'day').toDate();
      const toDate = moment().endOf('day').toDate();

      WorkflowManager.openTripsPage(device.id, fromDate, toDate);
    },
    scrollToSelectedRow() {
      this.$refs.dataGrid.scrollToSelectedRow();
    }
  },
};
</script>
